import React from 'react';
import { connect } from 'react-redux';
import { PointsForDrawingsDetailsView, getCMSObject } from 'sg-ui-components';

import { useParams } from 'react-router';
import Layout from '../Components/Layout';
import { mapDispatchToProps, mapStateToProps } from '../Store';
import siteConfig from '../promotion_config';

const PointsForDrawingsDetailsPage = ({ user, config, sweep, cmsSourceFirebase, actions, pointsForDrawings, match }) => {
    const params = useParams();
    const sweepId = params?.sweepId;

    const telescriptPointsForDrawingsDetails = getCMSObject('data.components.teleScripts.pointsForDrawingsDetails.jsonBlock');

    const promotionName = pointsForDrawings.pointsForDrawings.filter((val) => String(val.id) === String(sweepId))?.[0]?.name;

    const path = match?.path;

    return (
        <Layout
            {...{
                user,
                sweep,
                config,
                cmsSourceFirebase,
                actions,
                match,
                configReplacements: [
                    {
                        find: '{{PROMOTION_NAME}}',
                        replace: promotionName || 'Points for Drawings',
                    },
                ],
            }}>
            <PointsForDrawingsDetailsView
                user={user}
                actions={actions}
                pointsForDrawings={pointsForDrawings}
                sweepId={sweepId}
                options={{
                    loginUrl: `${siteConfig?.components?.pointsForDrawingsDetailsView?.loginUrl ?? '/login'}?redirect=${path?.replace(':sweepId', sweepId)}`,
                    registerUrl: siteConfig?.components?.pointsForDrawingsDetailsView?.registerUrl ?? '/register',
                    defaultNumEntries: siteConfig?.components?.pointsForDrawingsDetailsView?.defaultNumEntries ?? 1,
                }}
                telescript={telescriptPointsForDrawingsDetails}
                winner={undefined} // Missouri isn't allowed to winners due to legal.
                showWinner={false}
            />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PointsForDrawingsDetailsPage);
